// extracted by mini-css-extract-plugin
export default {"title-container":"style_title-container__tCCcb","titleContainer":"style_title-container__tCCcb","icon":"style_icon__KkUHR"};